// Import necessary modules and functions from external libraries and our own project
import { Libraries } from '@react-google-maps/api';
import * as authSelectors from '@redux/reducers/auth';
import { useSelector } from 'react-redux';
import { useGoogleMapsScript } from './useGoogleMapsScript'; // Import the custom hook
import { useEffect, useState } from 'react';

// Define a list of libraries to load from the Google Maps API
const libraries: Libraries = ['places', 'drawing', 'geometry'];

// Define a function component called MapProvider that takes a children prop
export function MapProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const user = useSelector(authSelectors.getAuthUser);
  const [showChildren, setShowChildren] = useState(false);

  const hasApiKey = !!(user && user.googleMapsApiKey);
  const { scriptLoaded, loadError } = useGoogleMapsScript(user?.googleMapsApiKey, libraries);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (!hasApiKey) {
      timer = setTimeout(() => setShowChildren(true), 500);
      return () => clearTimeout(timer);
    }
    if (scriptLoaded) {
      timer = setTimeout(() => setShowChildren(true), 500);
      return () => clearTimeout(timer);
    }
    setShowChildren(false);
    return () => {};
  }, [hasApiKey, scriptLoaded]);

  if (!hasApiKey) {
    if (!showChildren) return <p>Map Script is loading ...</p>;
    return <>{children}</>;
  }

  if (loadError) return <p>Encountered error while loading google maps</p>;

  if (!scriptLoaded || !showChildren) return <p>Map Script is loading ...</p>;

  // Return the children prop wrapped by this MapProvider component
  return <>{children}</>;
}
